<template>
    <div class="loader post-block">
        <div class="image"></div>
        <div 
            class="text" 
            v-for="i in 3"
            :key="i"
            :style="'width:'+textWidth()+'%'">
        </div>
    </div>
</template>

<script>

export default {
    name: 'loader-post-block',
    props: ['data'],
    methods: {
        textWidth(){
            const sizes = [ '30', '45', '76', '50', '38', '85', '69', '26', '36', '57', '71', '95' ]
            return sizes[Math.floor(Math.random()*sizes.length)];
        }
    }
}
</script>